import { ReactNode } from 'react';

import { keys } from 'dibs-ts-utils/exports/keys';

import {
    isFieldTrue,
    validateRequiredField,
    validateNoSpecialCharacters,
    validateFieldLength,
} from '../../../common/helpers/formValidationHelpers';
import { FormData, FormField } from '../../reducer';

// salesforce value
export const MAX_TEXT_AREA_LENGTH = 1000;

const validateTextAreaLength = validateFieldLength(MAX_TEXT_AREA_LENGTH);

function getErrors(values: Partial<FormData>): {
    [fieldName in FormField]?: ReactNode;
} {
    return {
        primaryInterest: validateRequiredField(values.primaryInterest),
        privateAdvisorAssistance:
            validateNoSpecialCharacters(values.privateAdvisorAssistance) ||
            validateTextAreaLength(values.privateAdvisorAssistance),
        priceRange: validateRequiredField(values.priceRange),
        smsPhoneNumber: isFieldTrue(values.receiveSmsUpdates)
            ? validateRequiredField(values.smsPhoneNumber)
            : null,
        whatsAppPhoneNumber: isFieldTrue(values.receiveWhatsAppUpdates)
            ? validateRequiredField(values.whatsAppPhoneNumber)
            : null,
    };
}

export function iFramedPromoPartnershipPCFormValidator(values: Partial<FormData>): {
    isValid: boolean;
    errors: { [fieldName in FormField]: ReactNode };
} {
    const fieldsToValidate = keys(values);

    const promoPartnershipPrivateClientFormErrors = getErrors(values);

    const validatedErrorFields = fieldsToValidate.reduce((acc, val) => {
        const errorMessage = promoPartnershipPrivateClientFormErrors[val];
        return {
            ...acc,
            [val]: errorMessage ? (
                <span data-tn={`${val}-error-message`}>{errorMessage}</span>
            ) : (
                errorMessage
            ),
        };
    }, {}) as {
        [fieldName in FormField]: ReactNode;
    };

    return {
        errors: validatedErrorFields,
        isValid: fieldsToValidate.every(key => !promoPartnershipPrivateClientFormErrors[key]),
    };
}
